<template>
    <section class="gmp-section gmp-mb-l">
        <div class="subpage-hero subpage-hero--no-padding">
            <div class="two-column-tout two-column-tout--fullbleed">
                <div class="two-column-tout__side">
                    <div class="two-column-tout__half-page two-column-tout__half-page--left">
                        <div class="two-column-tout__half-grid two-column-tout__half-grid--left">
                            <div class="two-column-tout__col">
                                <h1 class="h-c-headline h-c-headline--display-two">
                                    细节管理的体现
                                </h1>
                                <h2 class="h-u-mb-std two-column-tout__description">
                                    构成了企业在激烈市场竞争中获得成功的关键支柱。
                                    优化采购和库存管理控制成本、提升利润，保持品质一致性维护品牌，提升运营效率优化管理，最后，具备可扩展性保障未来的成长与扩展，这些因素共同决定了企业的生存能力和长期成功。
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="two-column-tout__side">
                    <div class="two-column-tout__image two-column-tout__image--right">
                        <picture>
                            <img src="@/assets/img/ds_special.png" alt="The finer points." class="gmp-no-grab " >
                        </picture>
                    </div>
                </div>

            </div>

        </div>



    </section>
</template>

<script>
    export default {
        name: "ES_two_column_fullbleed"
    }
</script>

<style lang="less">
h2{
    font-size: 18px;
    font-weight: 300;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}

</style>